/**
 * Adzuki.CardNumberEntry
 */

(function CardNumberEntry($, Adzuki)
{
	"use strict";

	var CardNumberEntry = {};

	// if amex_tokenization turned on for franchise and card type is Amex, expect a full card number up to 16 digits
	// $parent_div would be an element that parents the credit card type, cc number, etc
	CardNumberEntry.amexTokenization = function amexTokenization($parent_div)
	{
		var $card_type_input        = $parent_div.find('.credit-card-type'),
		    $number_fld             = $parent_div.find('.cc-num'),
		    tokenize_sensitive      = $number_fld.data('tokenize-sensitive'),
		    allow_amex_tokenization = $number_fld.data('allow-amex-tokenization'),
		    card_type               = $card_type_input.val(),
		    $sensitive              = $parent_div.find('.sensitive-data-warning'),
		    $number_div             = $number_fld.closest("div"),
		    $toggle_partial         = $number_div.find('.toggle-partial-container');

		if (tokenize_sensitive === 1) {
			return;
		}

		if ((card_type === "1") && (allow_amex_tokenization === 1)) {
			Adzuki.CardNumberEntry.expectFullCC($number_div);
			$toggle_partial.removeClass('hidden');
			$sensitive.removeClass('hidden');
		} else {
			Adzuki.CardNumberEntry.expectPartial($number_div);
			$toggle_partial.addClass('hidden');
			$sensitive.addClass('hidden');
		}
	};

	// user can click a link that allows them to enter a full CC or only the last 4 digits
	CardNumberEntry.togglePartialCC = function togglePartialCC($link)
	{
		var $parent_div     = $link.closest("div"),
		    $expect_full_cc = $parent_div.find('.expect-full-cc'),
		    $sensitive      = $parent_div.find('.sensitive-data-warning');

		// user doesnt want to enter full CC
		if ($expect_full_cc.val() === '1') {
			$link.html('Click here to enter full credit card number');
			Adzuki.CardNumberEntry.expectPartial($parent_div);
			$sensitive.addClass('hidden');

		// user wants to enter full CC
		} else {
			$link.html($link.data('original-text'));
			Adzuki.CardNumberEntry.expectFullCC($parent_div);
			$sensitive.removeClass('hidden');
		}
	};

	// looking for a full CC
	CardNumberEntry.expectFullCC = function expectFullCC($div)
	{
		var $number_fld     = $div.find('.cc-num'),
		    $cc_label       = $div.closest('.form-group').find('.credit_card_number_label'),
		    $expect_full_cc = $div.find('.expect-full-cc');

		$expect_full_cc.val(1);
		$number_fld.attr('maxLength', '16');
		$cc_label.html('<span class="required"></span> Card Number');
	};

	// looking for the last 4 digits of the CC
	CardNumberEntry.expectPartial = function expectPartial($div)
	{
		var $number_fld     = $div.find('.cc-num'),
		    $cc_label       = $div.closest('.form-group').find('.credit_card_number_label'),
		    cc_val          = $number_fld.val(),
		    $expect_full_cc = $div.find('.expect-full-cc');

		$expect_full_cc.val(0);

		$number_fld.attr('maxLength', '4');
		$number_fld.val(cc_val.substring(cc_val.length - 4));
		$cc_label.html('<span class="required"></span> Last 4 Digits');
	};


	$(document).ready(function documentReady()
	{
		$('.toggle-partial-cc').on('click', function click(e)
		{
			var $self = $(this);
			e.preventDefault();
			Adzuki.CardNumberEntry.togglePartialCC($self);
		});

		// if we need to constrain it to specific URLs
		// var pages = [
		// 	'ClientCreditCards/add',
		// 	'ClientCreditCards/edit',
		// 	'Households/add',
		// 	'Reservations/postPayment',
		// ];

		// Adzuki.onload(pages, function onload()
		// {
		// 	$('.toggle-partial-cc').on('click', function click(e)
		// 	{
		// 		var $self = $(this);
		// 		e.preventDefault();
		// 		Adzuki.CardNumberEntry.togglePartialCC($self);
		// 	});
		// });
	});

	Adzuki.CardNumberEntry = CardNumberEntry;

}(jQuery, window.Adzuki || {}));
